import { SeasonalThemeId } from '~/config/seasonalTheme.config';

import styles from './SeasonalTheme.module.css';

/** Classe à poser sur le conteneur de l'accueil TV (redéfinit les couleurs). */
export const seasonalContainerClass = (id: SeasonalThemeId | null) => (id ? styles[id] : undefined);
